enum DepositStatusEnum {
    CREATED = 'created',
    DONE = 'done',
    ERRORED = 'errored',
    EXTRACTING = 'extracting',
    FAILED = 'failed',
    IMPORTING = 'importing',
    VALIDATING = 'validating',
}
export default DepositStatusEnum;
